import mrpStyles from './../mrp.json'

export default {
  infoColor: mrpStyles.colors.TertiaryDarkBlue,
  infoBgColor: mrpStyles.colors.TertiaryLightBlue,
  infoBorderColor: mrpStyles.colors.TertiaryMidBlue,
  successColor: mrpStyles.colors.TertiaryDarkGreen,
  successBgColor: mrpStyles.colors.TertiaryLightGreen,
  successBorderColor: mrpStyles.colors.TertiaryMidGreen,
  errorColor: mrpStyles.colors.TertiaryDarkRed,
  errorBgColor: mrpStyles.colors.TertiaryLightRed,
  errorBorderColor: mrpStyles.colors.TertiaryMidRed
}
